var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elite-tabs-wrapper-content"},[_c('div',{staticClass:"custom-header"},[_c('h3',[_vm._v(_vm._s(`${_vm.importation.name}`)+" - "+_vm._s(_vm.$t("COMMON.LOGS")))])]),_c('log-list-table',{attrs:{"filterSubject":_vm.importation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }